import { mixNumber } from '../mix/number.mjs';
import { progress } from '../progress.mjs';
function fillOffset(offset, remaining) {
  var min = offset[offset.length - 1];
  for (var i = 1; i <= remaining; i++) {
    var offsetProgress = progress(0, remaining, i);
    offset.push(mixNumber(min, 1, offsetProgress));
  }
}
export { fillOffset };